import * as React from 'react'

import Container, { Props } from './Container'

export default function SortableCards(props: Props) {
  if (props.creatives.length === 0) {
    return null
  }

  return <Container {...props} />
}
